/*
Defines the custom element <ravel-sample>
*/

import { RavelSample } from './src/RavelSample.js';

customElements.define('ravel-sample', RavelSample);
